// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"1b6e2d61","113":"18115655","524":"27419b4b","580":"aa6b0ace"}[chunkId] + ".chunk.js";
};